import { Rotas } from 'enum';
import Agradecimento from 'pages/agradecimento/Agradecimento';
import CrescerNaPratica from 'pages/crescerNaPratica/CrescerNaPratica';
import Home from 'pages/home/Home';
import NotFound from 'pages/notFound/NotFound';
import Presenca from 'pages/presenca/Presenca';
import { Routes as DomRoutes, Route, useLocation } from 'react-router-dom';
import AgradecimentoNaoAssociado from '../pages/agradecimentoNaoAssociado/AgradecimentoNaoAssociado';
import NossoNegocioCooperativista from 'pages/nossoNegocioCooperativista';
const {
  presenca,
  agradecimento,
  agradecimentoNaoAssociado,
  naoEncontrado,
  crescerNaPratica,
  nossoNegocioCooperativista,
} = Rotas;

export default function Routes() {
  const location = useLocation();

  return (
    <DomRoutes location={location}>
      <Route path=':hash' element={<Home />} />
      <Route path={crescerNaPratica} element={<CrescerNaPratica />} />
      <Route
        path={nossoNegocioCooperativista}
        element={<NossoNegocioCooperativista />}
      />
      <Route path={presenca} element={<Presenca />} />
      <Route path={agradecimento} element={<Agradecimento />} />
      <Route
        path={agradecimentoNaoAssociado}
        element={<AgradecimentoNaoAssociado />}
      />
      <Route path={naoEncontrado} element={<NotFound />} />
      <Route path='*' element={<NotFound />} />
    </DomRoutes>
  );
}
